'use client';

import React, { memo, useState } from 'react';
import { LoadingSpinner } from '@crabs-ai/ds-react';
import ImageWithFallback from '@/shared/ui/images/ImageWithFallback';
import { MediaContentAdapterProps } from '../types';

// rendering-hoist-jsx: 정적 className 호이스팅
const spinnerContainerClassName =
  'absolute inset-0 flex items-center justify-center';

/**
 * 이미지 미디어 어댑터
 * - ImageWithFallback 사용
 * - mediaRef / onTimeUpdate 불필요
 * - rerender-memo: memo로 감싸 불필요 리렌더 차단
 */
export const ImageContent = memo(function ImageContent({
  url,
  name,
  onLoaded,
}: MediaContentAdapterProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleLoad = () => {
    setIsLoaded(true);
    onLoaded();
  };

  return (
    <>
      {!isLoaded ? (
        <div className={spinnerContainerClassName}>
          <LoadingSpinner
            size="large"
            className="fill-sys-cont-inverse-light"
          />
        </div>
      ) : null}
      <ImageWithFallback
        src={url}
        alt={name}
        width={1920}
        height={1080}
        className="max-h-full w-auto max-w-full object-contain"
        onLoad={handleLoad}
      />
    </>
  );
});
